import { render, staticRenderFns } from "./text-and-image.vue?vue&type=template&id=25d34944"
import script from "./text-and-image.vue?vue&type=script&lang=js"
export * from "./text-and-image.vue?vue&type=script&lang=js"
import style0 from "../core/ck-editor.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "./text-and-image.less?vue&type=style&index=1&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports